// Does this browser hold a usable offline snapshot for the tenant? Used at boot
// to decide between "start the app offline" and the "noch keine Daten" page.
import Dexie from "dexie";
import { dbName, openOfflineDb, getMeta, deleteOfflineDb } from "./db";

export const offlineDbName = dbName;

export async function hasSnapshot(tenant) {
  if (!tenant) return false;
  try {
    if (!(await Dexie.exists(dbName(tenant)))) return false;
    const db = openOfflineDb(tenant);
    return !!(await getMeta(db, "lastSync"));
  } catch {
    return false;
  }
}

export async function deleteSnapshotDb(tenant) {
  await deleteOfflineDb(tenant);
}
